import React from 'react';
import { Popover } from 'antd';
import { ShortMsgCheckIcon, TestShortMsgerrorIcon } from '../../../../images/svgIcons';
import { StyledTimeline, TimelineContainer } from '../../styles';
import { withTranslation } from 'react-i18next';

import { TIMELINE as trans } from './translationValues';
const NAMESPACE = ['TIMELINE'];

const Timeline = ({ data, t }) => {
  return (
    data.some(item => item.status !== null) && <StyledTimeline>
      {data?.map(item => {
        return (
          <TimelineContainer level={item?.level}>
            <div className="iconContainer">
              <div className="iconWrapper">
                {item?.status === 'Approved' ? (
                  <ShortMsgCheckIcon />
                ) : item?.status === 'Rejected' ? (
                  <TestShortMsgerrorIcon />
                ) : item?.status === 'Waiting for approval' && (
                  <div class="wave-anim-point">
                    <div class="wave"></div>
                  </div>
                )}
              </div>
              <div className="levelInfo">{t(trans.LEVEL_LABEL.key, trans.LEVEL_LABEL.value, { level: item.level })}</div>
            </div>

            {item?.status && (
              <div className="timelineInfo">
                <div className="dashedVerticalLine"></div>
                <div>
                  {item?.status === 'Rejected' ? (
                    <Popover
                    overlayClassName="timelinePopover"
                    trigger="hover"
                    content={
                      <>
                        <p className="popoverHeading">{t(trans.REASON_LABEL.key, trans.REASON_LABEL.value)}:</p>
                        <p>{item?.rejectionReason}</p>
                        {item?.email?.length > 0 && <>
                          <p className="popoverHeading">{t(trans.NOTIFIED_USERS_LABEL.key, trans.NOTIFIED_USERS_LABEL.value)}:</p>
                          <div className="userEmails">
                            {item?.email?.map(emailId => (
                              <p>{emailId}</p>
                            ))}
                          </div>
                        </>}
                      </>
                    }
                  >
                    <h4
                      style={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      {t(trans.REJECTED_LABEL.key, trans.REJECTED_LABEL.value)}
                    </h4>
                  </Popover>
                  ) : item?.status === 'Approved' ? (
                    <h4>{t(trans.APPROVED_LABEL.key, trans.APPROVED_LABEL.value)}</h4>
                  ) : <h4>{t(trans.WAITING_FOR_APPROVAL_LABEL.key, trans.WAITING_FOR_APPROVAL_LABEL.value)}</h4>}
                  
                  <p className="timeInfo">{item?.on}</p>
                  <p className="userInfo">{item?.by}</p>
                </div>
              </div>
            )}
          </TimelineContainer>
        );
      })}
    </StyledTimeline>
  );
};

export default withTranslation(NAMESPACE)(Timeline);
